import { User } from 'firebase/auth'
import { createContext } from 'react'

export interface AuthContext {
    user: User | null
}

const authContext = createContext<AuthContext>({} as AuthContext)

export default authContext